<script setup>
import {defineProps, defineEmits, computed} from "vue"
import dayjs from "dayjs";
const props = defineProps({
  modelValue: String,
});

const emit = defineEmits(['update:modelValue', 'onChange']);

const isEligibilityForPrize = computed(() => {
  if (!props.modelValue) return false;
  const birthDate = dayjs(props.modelValue);
  const age = dayjs('2024-12-31').diff(birthDate, 'year');
  return age >= 18 && age <= 35;
});

function changeValue(value) {
  if (value === null) {
    emit('update:modelValue', null)
  } else {
    emit('update:modelValue', value.format('YYYY-MM-DD'))
  }
  emit('onChange')
}

const selected_date = computed(() => {
  return props.modelValue ? dayjs(props.modelValue) : undefined
})
</script>

<template>
  <div>
    <label>Дата рождения</label>
    <a-date-picker
        @change="changeValue"
        :value="selected_date"
        format="YYYY-MM-DD"
        placeholder="Выберите дату"
    />
    <div v-if="isEligibilityForPrize">
      <p style="margin-top: 10px; color: green">Вы претендуете на денежный приз</p>
    </div>
    <div v-else>
      <p style="margin-top: 10px; color: red">Вы не можете претендовать на денежный приз</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>